var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9776 10.5224C13.7128 13.5915 11.1377 16 8 16C4.68629 16 2 13.3137 2 10C2 6.68629 4.68629 4 8 4C8.79954 4 9.56255 4.15639 10.2601 4.44024L9.25633 2.09808C8.84704 2.03352 8.42743 2 8 2C3.58172 2 0 5.58172 0 10C0 14.4183 3.58172 18 8 18C12.4183 18 16 14.4183 16 10C16 9.52898 15.9593 9.06748 15.8812 8.6188L13.9776 10.5224Z",
    fill: "#1D3066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.5L8 12L15 5",
    stroke: "#1D3066",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81213 1L10.8158 3.81578L8.00002 5.81945",
    stroke: "#1D3066",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestRun);
export default __webpack_public_path__ + "static/media/test-run.28dd5b620e2fd5a6c1070b3b32aac579.svg";
export { ForwardRef as ReactComponent };